import * as React from "react";
import { useState } from "react";
import TableContainer from "@mui/material/TableContainer";
import Table from "@mui/material/Table";
import TableRow from "@mui/material/TableRow";
import {Container, IconButton, TableCell, TableHead} from "@mui/material";
import TableBody from "@mui/material/TableBody";
import { TextareaAutosize } from '@mui/material';
import Button from "@mui/material/Button";
import styles from './editor.module.scss';
import { styled } from '@mui/system';
import { RemoveCircle } from '@mui/icons-material';

const TableEditor = styled(Table)(({ theme }) => ({
    '& .MuiTableCell-root': {
            margin: 0,
            padding: 0,
            outline: 'none',
            background: 'white'
        },
        '& .MuiTableCell-head': {
            background: '#253858',
            paddingTop: '5px',
            paddingBottom: '5px',
            height: '10vh',
            borderRight: '1.5px solid #37516D'
        },
        '& .MuiTableCell-head button:hover': {
            color: 'red',
        },
        '& .MuiTableCell-head button': {
            position: 'initial',
            background: 'transparent',
            border: 'none',
            color: '#ab1111'
        },
        '& .MuiTableCell-body > textarea': {
            minHeight: '10vh',
            marginLeft: '5vh',
        },
        '& .MuiTableCell-root:first-child': {
            position: 'sticky',
            left: 0,
            zIndex: 1,
            borderRight: '1px solid #37516D',
            borderLeft: '1px solid #37516D',
            background: 'white',
            fontSize: '15px',
            textAlign: 'center',
            padding: '0px 55px 0px 35px'
        },
        '& .MuiTableCell-head:first-child': {
            background: "#253858"
        },
        '& .MuiTableCell-body:first-child': {
            padding: '1em 2px',
        },
        '& .MuiTableCell-head.textarea': {
            fontSize: '20px',
            fontWeight: 'bold',
            textAlign: 'center',
            height: 'fit-content',
            fontFamily: 'Verdana',
        },
        '& .MuiTableRow-head': {
            position: 'sticky',
            top: '0',
            background:'white',
            zIndex: '2',
        },
}
));

interface DefaultTableProps {
    table?: { headers: {}, data: {} },
    updateData?: (e, rowKey, colKey) => void,
    addColumn?: () => void,
    removeColumn?: (e) => void,
    updateHeaders?: (e, colKey) => void
}  

const DefaultTable = (props: DefaultTableProps): JSX.Element => {
    let { table, updateData, addColumn, removeColumn, updateHeaders } = props;
    let headerKeys = Object.keys(table.headers);
    headerKeys.unshift("state")

    //Text Area Wrapper in order to simultaneously hold and set a value for each cell
    const TextAreaWrapper = (props): JSX.Element => {
        let {colKey, rowKey, isHeader} = props
        const [value, setValue] = useState(isHeader ? table.headers[colKey] : table.data[rowKey][colKey]);

        return (isHeader ?
            <TextareaAutosize
                style={{ color: 'white', fontSize: '14px', textAlign: 'center' }}
                onChange={(e) => {
                    updateHeaders(e, colKey);
                    setValue(table.headers[colKey]);
                } }
                value={value}   /> :
            <TextareaAutosize
                style={{ width: '80%' }}
                onChange={(e) => {
                    updateData(e, rowKey, colKey);
                    setValue(table.data[rowKey][colKey]);
                } }
                value={value}  />
        )
    };

    //map all body cells with a text area containing the passed state
    const populateRow = (row, rowKey) => {
        return( headerKeys.map( key => {
            if (key === "state") {
                return <TableCell >
                        {row["state"]}
                    </TableCell>
            } else {
                    return <TableCell>
                            <TextAreaWrapper key={key} colKey={key} rowKey={rowKey} isHeader={false}/>
                        </TableCell>
                }
            }
        ))
    };

    //create the rows for each state
    const createAllRows = (data) => {
        let rows = Object.keys(data);
        return rows.map( row => {
            return <TableRow key={row}>{populateRow(data[row], row)}</TableRow>
        })
    };

    //Create the header row
    const createHeaders = () => {
        return headerKeys.map(key => {
            return ( key!=="state" ? <TableCell>
                <Container className={styles.headerContainer} >
                    <IconButton 
                        disableRipple 
                        id={key}
                        onClick={(e) => {removeColumn(e)}}
                    > 
                        <RemoveCircle /> 
                    </IconButton>
                    <TextAreaWrapper 
                        colKey={key} rowKey={null} isHeader={true}
                    />
                </Container>
            </TableCell> : null)
        })
    };

    //Component that maps the passed table data
    return(
        <div>
            <Button className={styles.add} style={{float: 'left', bottom: '15px'}} onClick={addColumn}>
                Add Column
            </Button>
            <TableContainer style={{maxHeight: 650, overflow: "scroll", 
        }}>
                <TableEditor aria-label="default-dense-table" style={{borderCollapse: 'separate', 
                // borderRadius: '10px',
                }}>
                    <TableHead>
                        <TableRow key={"headerRow"}>
                            <TableCell/>
                            {createHeaders()}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {createAllRows(table.data)}
                    </TableBody>
                </TableEditor>
            </TableContainer>
        </div>
    )
};

export default DefaultTable;